module.exports = __webpack_public_path__ + "media/images/article-photo-a01cf147c7e1d965fc5e61de7ae3c3fc.jpg";